module.exports = __webpack_public_path__ + "img/chart_bg.20cd6559.png";